export default "__VITE_ASSET__AUqXzq68__"